module.exports = __webpack_public_path__ + "img/all_select_icon.56101159.svg";